import React from 'react';

export const RecursoEducativo = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-[#f0f4f8] text-center p-4">
      <img
        src="./img/working.png"
        alt="Sitio en construcción"
        className="w-40 md:w-52 mb-6 animate-bounce"
      />
      <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
        Página en construcción
      </h1>
      <p className="text-lg md:text-xl text-gray-600">
        ¡Estamos trabajando para traerte una mejor experiencia!
      </p>

    </div>

  );
};
